import vehicleSaga from './sagas/VehicleSaga';

export default [
    vehicleSaga,
];